
export default {
  name:"RejectedDueDiligence",
    components:{
    },
    setup() {
  }
    
};
